import {StyleSheet} from 'react-native';
import Typography from '../../../constants/Typography';

export const createQuickAssistBannerStyles = (theme: any) =>
  StyleSheet.create({
    bannerContainer: {
      flexDirection: Typography.flexDirection.row,
      alignItems: Typography.textAlign.centerAlign,
      justifyContent: Typography.contentAlign.flexEnd,
      backgroundColor: theme.QABannerBG,
      borderRadius: Typography.radius.radius8,
      paddingVertical: Typography.padding.padding12,
      paddingHorizontal: Typography.padding.padding20,
    },
    ctaContainerStyle: {
      alignItems: Typography.textAlign.centerAlign,
      justifyContent: Typography.textAlign.centerAlign,
    },
  });